export const typeOfGeneratingEntityOptions = {
    "area": 1,
    "authority": 2,
    "customer": 3,
    "others": 4,
};